export default `vec3 Q,S;
    float d=1., a;
    Q=S=mod(p,10.)-5.;
    a=1.;
    for(int j=0;j++<9;) 
      Q=2.*clamp(Q,-1.,1.)-Q,
      d=max(3./max(dot(Q,Q),0.001),1.),
      Q=2.*Q*d+S,
      a=2.*a*d+1.;
    return d=(length(Q)-9.)/max(a,0.001);
  }`